import {ChangeDetectionStrategy, Component, Inject, Optional} from "@angular/core";
import {DateControllerStateDirective} from "../../directives";
import {map} from "rxjs/operators";
import {INT_MONTH_LIST_TOKEN} from "../../../shared/tokens/int-month-list.token";
import {
  getNMYPair,
  getPMYPair,
  INT_MONTH_IN_YEAR_TOKEN,
  TCalendarMY
} from "../../../shared";
import {DomSanitizer} from "@angular/platform-browser";
import {intChevronLeft, intChevronRight} from "../../../../../assets";
import {Observable} from "rxjs";

@Component({
  selector: 'int-month-selector',
  templateUrl: './int-month-selector.component.html',
  styleUrls: ['./int-month-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntMonthSelectorComponent {

  month$: Observable<string> = this.controller.changePluginState$
    .pipe(map((date: Date) => {
      const monthID = date.getMonth();
      return this.months[monthID];
    }))

  constructor(
    @Inject(INT_MONTH_LIST_TOKEN) private readonly months: Array<string>,
    @Optional()
    @Inject(DateControllerStateDirective) private readonly controller: DateControllerStateDirective,
    @Inject(INT_MONTH_IN_YEAR_TOKEN) private readonly monthInYear: number,
    private readonly sanitizer: DomSanitizer
  ) {

    if(!this.controller) {
      console.warn('Please provide intDateStateController [use DateControllerStateDirective]')
    }
  }

  getPrevIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(intChevronLeft);
  }

  getNextIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(intChevronRight);
  }

  setMonth(setter: (a: number, b: number, c: number) => TCalendarMY) {
    const {month: currentMonth, year: currentYear} = this.controller.pluginDateStateForNavigation;
    const {month, year} = setter(currentMonth, currentYear, this.monthInYear);
    this.controller.setPluginDate(year, month);
  }

  prev() {
    this.setMonth(getPMYPair);
  }
  next() {
    this.setMonth(getNMYPair);
  }

}
